<template>
    <GameCard
        v-for="(game, index) in games"
        :key="game.hru"
        :game="game"
        :ctrContext="ctrContexts[index]"
        :data-interface-target="`game-number-${props.offset + index + 1}`"
        type="rectangle"
        responsive
        withBadges
        :lazy="props.offset + index >= EAGER_THUMBS"
        :preload="props.offset + index === 0"
    />
</template>
<script lang="ts" setup>
import { computed } from 'vue'

import GameCard from '@/components/GameCard/GameCard.vue'
import { useCtrListContexts } from '@/composables/use-ctr-context'
import type { ShortGameZipType } from '@/types'
import { unzipShortGame } from '@/utils/helpers'

const EAGER_THUMBS = 8

const props = defineProps<{
    games: ShortGameZipType[]
    positions: number[]
    offset: number
    slateId?: string
    total?: number
}>()

const games = computed(() => props.games.map(unzipShortGame))

// the placement of the backend decision events
const ctrContexts = useCtrListContexts(
    () => games.value,
    () => ({ placement: 'mobile_curated', slateId: props.slateId, positions: props.positions, total: props.total }),
)
</script>
